import { render, staticRenderFns } from "./RequestHeaders.vue?vue&type=template&id=3bcf46e8&scoped=true"
import script from "./RequestHeaders.vue?vue&type=script&lang=js"
export * from "./RequestHeaders.vue?vue&type=script&lang=js"
import style0 from "./RequestHeaders.vue?vue&type=style&index=0&id=3bcf46e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf46e8",
  null
  
)

export default component.exports